export default {
    computed: {
        settings() {
            return this.$store.state.settings;
        },
        editor() {
            return this.$store.state.authors[this.document.data.editor?.id];
        },
        hasEditor() {
            return Boolean(this.editor?.data.name || this.editorFallback);
        },
        editorFallback() {
            const fallback = this.settings.editor_fallback;
            return this.$validateText(fallback) 
                ? fallback 
                : null;
        },
        editorFallbackTooltip() {
            const tooltip = this.settings.editor_fallback_tooltip;
            if (!this.$validateText(tooltip)) {
                return null;
            }

            return this.$prismic.asHtml(tooltip);
        },
        editorComponent() {
            return this.editor
                ? 'nuxt-link'
                : 'div';
        },
        editorAttrs() {
            return this.editor
                ? { to: this.$prismic.linkResolver(this.editor) }
                : { class: 'editor-fallback' };
        },
        reviewedByEditor() {
            const name = this.editor
                ? this.editor.data.name
                : this.editorFallback;
            return this.$translate('authority_box_reviewed_by_editor', 'Granskad av {editor}')
                .replace('{editor}', `<span>${name}</span>`);
        }
    }
};
